import { render, staticRenderFns } from "./ApiCallLog.vue?vue&type=template&id=36c524b4&scoped=true&"
import script from "./ApiCallLog.vue?vue&type=script&lang=js&"
export * from "./ApiCallLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c524b4",
  null
  
)

export default component.exports